export const getCategories = () => {
    const categoryArray = [
        {
            categoryCode: 'NABCOMMON',
            categoryName: 'NAB Common Uploads'
        },
        {
            categoryCode: 'NABSUPER',
            categoryName: 'NAB Super Uploads'
        },
        {
            categoryCode: 'NABNONSUPER',
            categoryName: 'NAB Non-Super Uploads'
        },
        {
            categoryCode: 'NABNONSUPER',
            categoryName: 'NAB Non-Super Uploads'
        },
    ];
    
    return categoryArray;
}